import { library } from "@fortawesome/fontawesome-svg-core";

// ********* Please add new icons alphabetically **********

import { faLinkedin, faTwitter } from "@fortawesome/free-brands-svg-icons";
import { faSquare as faSquareRegular } from "@fortawesome/free-regular-svg-icons";

import {
  faAddressCard,
  faAnglesDown,
  faAnglesUp,
  faArrowDown,
  faArrowLeft,
  faArrowRight,
  faArrowRightArrowLeft,
  faArrowRightFromBracket,
  faArrowsDownToPeople,
  faArrowsToDot,
  faArrowTrendUp,
  faArrowTurnUp,
  faArrowUp,
  faArrowUpRightDots,
  faArrowUpRightFromSquare,
  faAsterisk,
  faAt,
  faAward,
  faBan,
  faBars,
  faBell,
  faBorderAll,
  faBullhorn,
  faBullseye,
  faCalendar,
  faCalendarAlt,
  faCaretDown,
  faCaretLeft,
  faCaretRight,
  faCaretUp,
  faChartSimple,
  faCheck,
  faCheckSquare,
  faCircle,
  faCircleArrowDown,
  faCircleArrowUp,
  faCircleCheck,
  faCircleExclamation as faExclamationCircle,
  faCircleXmark,
  faClock,
  faClose,
  faCloudDownload,
  faColumns,
  faCrosshairs,
  faDiagramNext,
  faDisplay,
  faDoorOpen,
  faDownload,
  faEdit,
  faEllipsis,
  faEnvelope,
  faEnvelopeOpen,
  faEye,
  faFileAlt,
  faFilter,
  faFlag,
  faGear,
  faGlobe,
  faGripLines,
  faGripVertical,
  faHourglassEnd,
  faHourglassStart,
  faInfo,
  faInfoCircle,
  faKey,
  faLayerGroup,
  faLink,
  faList,
  faListCheck,
  faLocationDot,
  faLock,
  faMagnifyingGlass,
  faMedal,
  faPaperclip,
  faPencil,
  faPersonCircleQuestion,
  faPieChart,
  faPlay,
  faPlus,
  faRectangleXmark,
  faRepeat,
  faReply,
  faRetweet,
  faRightFromBracket,
  faRightLeft,
  faRotate,
  faRotateLeft,
  faSave,
  faShareFromSquare,
  faSignal,
  faSignOutAlt,
  faSitemap,
  faSliders,
  faSpinner,
  faSquare,
  faSquareCaretLeft,
  faSquareCaretRight,
  faStickyNote,
  faStopwatch,
  faSuitcase,
  faTableCellsLarge,
  faTrash,
  faTriangleExclamation,
  faUnlock,
  faUpload,
  faUser,
  faUsersGear,
  faVideo,
  faVideoSlash,
  faXmark,
} from "@fortawesome/free-solid-svg-icons";

library.add(
  faAddressCard,
  faAnglesDown,
  faAnglesUp,
  faArrowDown,
  faArrowLeft,
  faArrowRight,
  faArrowRightArrowLeft,
  faArrowRightFromBracket,
  faArrowsDownToPeople,
  faArrowsToDot,
  faArrowTrendUp,
  faArrowTurnUp,
  faArrowUp,
  faArrowUpRightDots,
  faArrowUpRightFromSquare,
  faAsterisk,
  faAt,
  faAward,
  faBan,
  faBars,
  faBell,
  faBorderAll,
  faBullhorn,
  faBullseye,
  faCalendar,
  faCalendarAlt,
  faCaretDown,
  faCaretLeft,
  faCaretRight,
  faCaretUp,
  faChartSimple,
  faCheck,
  faCheckSquare,
  faCircle,
  faCircleArrowDown,
  faCircleArrowUp,
  faCircleCheck,
  faCircleXmark,
  faClock,
  faClose,
  faCloudDownload,
  faColumns,
  faCrosshairs,
  faDiagramNext,
  faDisplay,
  faDoorOpen,
  faDownload,
  faEdit,
  faEllipsis,
  faEnvelope,
  faEnvelopeOpen,
  faExclamationCircle,
  faEye,
  faFileAlt,
  faFilter,
  faFlag,
  faGear,
  faGlobe,
  faGripLines,
  faGripVertical,
  faHourglassEnd,
  faHourglassStart,
  faInfo,
  faInfoCircle,
  faKey,
  faLayerGroup,
  faLink,
  faLinkedin,
  faList,
  faListCheck,
  faLocationDot,
  faLock,
  faMagnifyingGlass,
  faMedal,
  faPaperclip,
  faPencil,
  faPersonCircleQuestion,
  faPieChart,
  faPlay,
  faPlus,
  faRectangleXmark,
  faRepeat,
  faReply,
  faRetweet,
  faRightFromBracket,
  faRightLeft,
  faRotate,
  faRotateLeft,
  faSave,
  faShareFromSquare,
  faSignal,
  faSignOutAlt,
  faSitemap,
  faSliders,
  faSpinner,
  faSquare,
  faSquareCaretLeft,
  faSquareCaretRight,
  faSquareRegular,
  faStickyNote,
  faStopwatch,
  faSuitcase,
  faTableCellsLarge,
  faTrash,
  faTriangleExclamation,
  faTwitter,
  faUnlock,
  faUpload,
  faUser,
  faUsersGear,
  faVideo,
  faVideoSlash,
  faXmark,
);

/* add some free styles */

export default library;
